<div class="container">
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Add Branch </h4>
    </div>
    <div class="card-body">

      <form [formGroup]="entityForm" (ngSubmit)="onSubmit()">
        <div class="row">
 
  <!-- Name -->
  <div class="col-md-4 form-group">
    <label for="name" class="form-label">Group Name</label>
    <input type="text" id="name" class="form-control" formControlName="name" placeholder="Enter group name..." />
    <span class="text-danger" *ngIf="entityForm.get('name')?.invalid && entityForm.get('name')?.touched">
      <small *ngIf="entityForm.get('name')?.errors?.['required']">Name is required.</small>
          <small *ngIf="entityForm.get('name')?.errors?.['maxlength']">Max length is 20 characters.</small>

    </span>
  </div>

  <!-- Min Age -->
  <div class="col-md-4 form-group">
    <label for="minAge" class="form-label">Min Age</label>
    <input type="number" id="minAge" class="form-control" formControlName="minAge" placeholder="Enter min age..." />
    <span class="text-danger" *ngIf="entityForm.get('minAge')?.invalid && entityForm.get('minAge')?.touched">
      <small *ngIf="entityForm.get('minAge')?.errors?.['required']">Min Age is required.</small>
      <small *ngIf="entityForm.get('minAge')?.errors?.['min']">Min Age must be 0 or higher.</small>
    </span>
  </div>

  <!-- Max Age -->
  <div class="col-md-4 form-group">
    <label for="maxAge" class="form-label">Max Age</label>
    <input type="number" id="maxAge" class="form-control" formControlName="maxAge" placeholder="Enter max age..." />
    <span class="text-danger" *ngIf="entityForm.get('maxAge')?.invalid && entityForm.get('maxAge')?.touched">
      <small *ngIf="entityForm.get('maxAge')?.errors?.['required']">Max Age is required.</small>
      <small *ngIf="entityForm.get('maxAge')?.errors?.['min']">Max Age must be 0 or higher.</small>
    </span>
  </div>
</div>


        <!-- Submit and Reset Buttons -->
        <div class="col-12 d-flex justify-content-center">
          <div class="d-flex justify-content-between ">
            <button type="submit" class="btn btnn mx-1" rippleEffect>ADD Branche </button>
            <!-- <button type="button" class="btn btn-light" (click)="resetForm()" rippleEffect>Reset</button> -->
          </div>
        </div>

      </form>
    </div>
  </div>
</div>